import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Plus, Receipt } from 'lucide-react';

const ViewOrdersDialog = ({
  open,
  onOpenChange,
  selectedTable,
  tableOrders,
  onOpenBilling
}) => {
  const orders = selectedTable ? tableOrders[selectedTable.id] : [];

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Table {selectedTable?.table_number} - Running Orders</DialogTitle>
        </DialogHeader>
        {selectedTable && orders && (
          <div className="space-y-4">
            <div className="space-y-2 max-h-60 overflow-y-auto">
              {orders.map((order, idx) => (
                <div key={order.id} className="p-3 border rounded-lg">
                  <div className="flex justify-between items-center mb-2">
                    <span className="font-medium">Order #{idx + 1}</span>
                    <span className="text-sm text-muted-foreground">
                      {new Date(order.created_at).toLocaleTimeString()}
                    </span>
                  </div>
                  <div className="text-sm space-y-1">
                    {order.items?.map((item, i) => (
                      <div key={i} className="flex justify-between">
                        <span>{item.item_name} × {item.quantity}</span>
                        <span>₹{item.price * item.quantity}</span>
                      </div>
                    ))}
                  </div>
                  <div className="flex justify-between font-medium mt-2 pt-2 border-t">
                    <span>Total</span>
                    <span>₹{order.total_amount}</span>
                  </div>
                </div>
              ))}
            </div>
            <div className="flex gap-2">
              <Button variant="outline" className="flex-1" onClick={() => onOpenChange(false)}>
                <Plus className="h-4 w-4 mr-2" /> Add More Items
              </Button>
              <Button className="flex-1" onClick={() => { onOpenChange(false); onOpenBilling(selectedTable); }}>
                <Receipt className="h-4 w-4 mr-2" /> Generate Bill
              </Button>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ViewOrdersDialog;
